export enum CookieNotificationStatusEnum {
    info = 'info',
    warning = 'warning',
    success = 'success',
    error = 'error',
}
